import { FC, ReactNode } from 'react';
import { Box, ButtonBase, Tooltip } from '@mui/material';
import { Check } from '@mui/icons-material';
import { swatchCheckSx, swatchGridSx, swatchSx } from './styles';

export interface TextColorSwatch {
  color: string;
  /** Tooltip and accessible name: the colour's name, or its hex. */
  label: string;
}

interface TextColorSwatchesProps {
  swatches: readonly TextColorSwatch[];
  /** The colour of the selection: its swatch is marked. */
  selectedColor: string | undefined;
  onPick: (color: string) => void;
  dataQa: string;
  /** After the swatches, in the same grid (the spectrum that opens the picker). */
  children?: ReactNode;
}

export const TextColorSwatches: FC<TextColorSwatchesProps> = ({
  swatches,
  selectedColor,
  onPick,
  dataQa,
  children,
}) => (
  <Box sx={swatchGridSx} data-qa={dataQa}>
    {swatches.map(({ color, label }) => {
      const isSelected = color === selectedColor;
      return (
        <Tooltip key={color} title={label}>
          <ButtonBase
            onClick={() => onPick(color)}
            aria-label={label}
            aria-pressed={isSelected}
            sx={swatchSx(color)}
            data-color={color}
          >
            {isSelected && <Check sx={swatchCheckSx} />}
          </ButtonBase>
        </Tooltip>
      );
    })}
    {children}
  </Box>
);
